import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import styles from './model-content-error.module.scss';
import errorIcon from "../../../../../assets/order-summary-error.svg"

const ErrorModalContent = ({title, message, onClose}) => {

  return (
    <div className={styles['error']}>
      <Row>
        <Col lg={12}>
          <div>
            <h1>{title}</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div>
            <img alt="Error" src={errorIcon} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['message']}>
            <p>{message}</p>
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col lg={12}>
          <div className={styles['close-button']}>
            <Button variant="secondary" onClick={() => onClose()}>
              CLOSE
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default ErrorModalContent;
